export const HALEON_APP_HEADER = "x-haleon";
